<template>
  <section class="section" id="coupon-panel">
    <div class="container">
      <div class="header">
        <h1 class="subtitle has-text-centered">
          {{ $t("couponDownload.title") }}
        </h1>
        <hr />
      </div>

      <div v-for="file in files" :key="file" class="columns is-vcentered">
        <div class="column is-narrow">
          <button class="button" @click.prevent="download(file)">
            <b-icon icon="file-download"></b-icon>
          </button>
        </div>
        <div class="column">Arquivo {{ tipo(file) }}</div>
      </div>

      <div v-if="showNoFile">
        {{ $t("couponDownload.nfNotFound") }}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ClientCouponComp",

  data() {
    return {
      files: [],
      showNoFile: false
    };
  },

  methods: {
    tipo(file) {
      if (file) {
        if (file.toLowerCase().endsWith(".pdf")) {
          return "PDF";
        } else if (file.toLowerCase().endsWith(".xml")) {
          return "XML";
        }
      }
      return "";
    },
    download(file) {
      window.location.href = file;
    }
  },

  mounted() {
    this.$store.dispatch("getClientCoupon", this.$route.query.t).then(e => {
      this.files = e.data.payload.files;
      this.showNoFile = !this.files || this.files.length == 0;
    });
  }
};
</script>

<style scoped>
#coupon-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}

.header {
  position: sticky;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
